import React from 'react';

function ConfirmModal({
  open,
  title,
  body,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  loadingLabel = 'Processando...',
  danger = false,
  loading = false,
  onCancel,
  onConfirm,
  confirmDisabled = false,
}) {
  if (!open) return null;

  const headerClass = `f2b-modal-header${danger ? ' f2b-modal-header-danger' : ''}`;
  const confirmClass = `f2b-btn-modal ${danger ? 'f2b-btn-modal-danger' : 'f2b-btn-modal-confirm'}`;

  return (
    <div className="f2b-modal-overlay">
      <div className="f2b-modal-card">
        <header className={headerClass}>
          <p className="f2b-modal-title">{title}</p>
          <button
            type="button"
            className="f2b-modal-close-btn"
            onClick={onCancel}
            disabled={loading}
            aria-label="Fechar"
          >
            &times;
          </button>
        </header>
        <section className="f2b-modal-body">
          {typeof body === 'string' ? <p>{body}</p> : body}
        </section>
        <footer className="f2b-modal-footer">
          <button
            type="button"
            className="f2b-btn-modal f2b-btn-modal-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={confirmClass}
            onClick={onConfirm}
            disabled={loading || confirmDisabled}
          >
            {loading ? loadingLabel : confirmLabel}
          </button>
        </footer>
      </div>
    </div>
  );
}

export default ConfirmModal;
